function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _rect, _path, _path2, _path3, _path4, _path5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
import { Platform } from 'react-native';
import { createElement } from 'react';
var SvgHandleDifficultMoments = function SvgHandleDifficultMoments(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    x: 4,
    y: 4,
    fill: "#FFE4E6",
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#9F1239",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22 30h38c5 0 9 4 9 9v14c0 5-4 9-9 9H38l-10 8v-8h-6c-5 0-9-4-9-9V39c0-5 4-9 9-9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F43F5E",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M31 42h24m-24 7h16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#10B981",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M68 44h30c5 0 9 4 9 9v14c0 5-4 9-9 9h-4v8l-10-8H68c-5 0-9-4-9-9V53c0-5 4-9 9-9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#10B981",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m76 55 4 4 8-9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F43F5E",
    d: "M56 82c-4-4-4-9 0-12 3-3 7-2 8 1 1-3 5-4 8-1 4 3 4 8 0 12l-8 8z"
  })));
};
if (Platform.OS === 'web') {
  var ForwardRefNativeSvgIcon = /*#__PURE__*/React.forwardRef(SvgHandleDifficultMoments);
  SvgHandleDifficultMoments = function SvgHandleDifficultMoments(props, ref) {
    return /*#__PURE__*/createElement(ForwardRefNativeSvgIcon, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  };
}
var ForwardRef = /*#__PURE__*/forwardRef(SvgHandleDifficultMoments);
export default ForwardRef;